__turbopack_context__.v({
  "subs-diff-container": "use-subs-diff-module-scss-module__LZh0Tq__subs-diff-container",
  "subs-diff-wrapper": "use-subs-diff-module-scss-module__LZh0Tq__subs-diff-wrapper",
});
